export const MOCKUP_STORAGE_KEY = "mybuildid-merch-mockup-studio-v1";
export const MOCKUP_SCHEMA_VERSION = 6;

export const DEFAULT_GARMENT_ID = "ascolour-5082";
export const PRINT_TECHNIQUE = "DTFlex";
export const PRINTFUL_DTFLEX_MAX_WIDTH_INCHES = 12;
export const PRINTFUL_DTFLEX_MAX_HEIGHT_INCHES = 16;
export const IDENTITY_FRONT_PRINT_WIDTH_INCHES = 4;
export const IDENTITY_BACK_PRINT_WIDTH_INCHES = 11;
export const IDENTITY_FRONT_PRINT_WIDTH_RATIO = IDENTITY_FRONT_PRINT_WIDTH_INCHES / PRINTFUL_DTFLEX_MAX_WIDTH_INCHES;
export const IDENTITY_BACK_PRINT_WIDTH_RATIO = IDENTITY_BACK_PRINT_WIDTH_INCHES / PRINTFUL_DTFLEX_MAX_WIDTH_INCHES;

// Front uses the exact supplied horizontal-logo ratio. Back bounds are an estimate
// of the visible composition because the production SVG does not expose path bounds.
export const IDENTITY_FRONT_VISIBLE_ASPECT_RATIO = 991 / 185;
export const IDENTITY_BACK_VISIBLE_ASPECT_RATIO_ESTIMATE = 3300 / 3460;

export const PREVIEW_SIZE_MODES = ["visual", "trueSize"];
export const PREVIEW_ZOOM_OPTIONS = ["fit", "50", "100", "150", "200"];

export const GARMENT_COLORS = [
  { id: "Faded Black", hex: "#171717", artworkTone: "dark" },
  { id: "Faded Coal", hex: "#383838", artworkTone: "dark" },
  { id: "Faded Bone", hex: "#d8d0c2", artworkTone: "light" }
];

// Coordinates are percentages of the responsive garment preview surface.
export const IDENTITY_FRONT_DEFAULT_PLACEMENT = {
  scale: 0.5,
  x: 50,
  y: 28
};

export const IDENTITY_BACK_DEFAULT_PLACEMENT = {
  scale: 0.62,
  x: 50,
  y: 39
};

export const IDENTITY_FRONT_PLACEMENT_LIMITS = {
  scale: { min: 0.4, max: 0.8, step: 0.01 },
  x: { min: 45, max: 55, step: 0.1 },
  y: { min: 18, max: 38, step: 0.1 }
};

export const IDENTITY_BACK_PLACEMENT_LIMITS = {
  scale: { min: 0.5, max: 1.1, step: 0.01 },
  x: { min: 40, max: 60, step: 0.1 },
  y: { min: 30, max: 65, step: 0.1 }
};

export const GARMENT_CALIBRATION_LIMITS = {
  printArea: {
    left: { min: 15, max: 45, step: 0.1 },
    top: { min: 8, max: 35, step: 0.1 },
    width: { min: 20, max: 70, step: 0.1 },
    height: { min: 25, max: 75, step: 0.1 }
  },
  calibration: {
    xOffset: { min: -20, max: 20, step: 0.1 },
    yOffset: { min: -20, max: 20, step: 0.1 },
    scaleMultiplier: { min: 0.5, max: 1.5, step: 0.01 }
  }
};

export function getGarmentColor(colorId) {
  return GARMENT_COLORS.find((color) => color.id === colorId) || GARMENT_COLORS[0];
}
